import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PaymentProfileStatus,
  PaymentProfileDashboardStatus
} from '../../models/_enum-collections';
import { PaymentProfileProgramType } from '../../models/payment-profile-program-type.model';
import { Vendor } from '../../models/vendor.model';
import { SettingsService } from '../common/settings.service';

@Injectable({
  providedIn: 'root'
})
export class VendorService {
  constructor(
    private http: HttpClient,
    public settings: SettingsService
  ) {}

  AddVendorInformation(vendorInfo: Vendor): Observable<any> {
    return this.http.post(this.settings.baseUrl + 'api/vendor/add', vendorInfo);
  }

  getPaymentProfileProgramType(): Observable<PaymentProfileProgramType[]> {
    return this.http.get<PaymentProfileProgramType[]>(
      this.settings.baseUrl + 'api/PartnerType/GetPaymentProfileProgramTypes'
    );
  }

  getStyleForPaymentProfileStatus(status: string) {
    switch (status) {
      case PaymentProfileStatus.Missing:
        return 'red';
      case PaymentProfileStatus.New:
        return 'yellow';
      case PaymentProfileStatus.Submitted_to_PC:
        return 'yellow';
      case PaymentProfileStatus.Completed:
        return 'green';
      case PaymentProfileStatus.Expired:
        return 'red';
      default:
        return 'red';
    }
  }

  getPaymentProfileStatus(status: string) {
    switch (status) {
      case PaymentProfileStatus.Missing:
        return PaymentProfileDashboardStatus.Missing;
      case PaymentProfileStatus.New:
        return PaymentProfileDashboardStatus.Requested;
      case PaymentProfileStatus.Submitted_to_PC:
        return PaymentProfileDashboardStatus.Pending_Completion;
      case PaymentProfileStatus.Completed:
        return PaymentProfileDashboardStatus.Completed;
      case PaymentProfileStatus.Expired:
        return PaymentProfileDashboardStatus.Expired;
      default:
        return PaymentProfileDashboardStatus.Missing;
    }
  }
}
